import { useQuery } from '@apollo/client'

import { GET_USER, GetUserQuery, GetUserQueryVariables } from '@/graphql'

import { UserAvatar, UserAvatarPropsOptions } from './UserAvatar'

type Props = {
  id: string
} & UserAvatarPropsOptions

export const UserAvatarWithQuery: React.FC<Props> = props => {
  const { id, ...rest } = props
  const { data } = useQuery<GetUserQuery, GetUserQueryVariables>(GET_USER, {
    variables: { id },
  })
  const user = data?.user

  return user ? (
    <UserAvatar
      firstName={user.firstName}
      lastName={user.lastName}
      profileImageUrl={user.profileImage?.url}
      {...rest}
    />
  ) : null
}
